import { getRouteApi } from "@tanstack/react-router"
import { useStore } from "zustand"
import { createStore } from "zustand/vanilla"

import type { WwmEventRoleKey } from "@/core/guild-events/types"

type GuildEventRsvpState = "attending" | "tentative" | "not_attending"

type RsvpOverrideForm = {
  rsvpState: GuildEventRsvpState
  roleKey: WwmEventRoleKey | ""
  memberIdInput: string
}

type GuildEventsAdminDetailState = {
  rsvpOverride: RsvpOverrideForm
}

type GuildEventsAdminDetailActions = {
  setRsvpState: (state: GuildEventRsvpState) => void
  setRoleKey: (key: WwmEventRoleKey | "") => void
  setMemberIdInput: (value: string) => void
  resetRsvpOverride: () => void
}

const INITIAL_RSVP_OVERRIDE: RsvpOverrideForm = {
  rsvpState: "attending",
  roleKey: "",
  memberIdInput: "",
}

export const createGuildEventsAdminDetailStore = () => {
  const store = createStore<GuildEventsAdminDetailState>(() => ({
    rsvpOverride: { ...INITIAL_RSVP_OVERRIDE },
  }))

  const actions: GuildEventsAdminDetailActions = {
    setRsvpState: (rsvpState) =>
      store.setState((s) => ({
        rsvpOverride: { ...s.rsvpOverride, rsvpState },
      })),
    setRoleKey: (roleKey) =>
      store.setState((s) => ({
        rsvpOverride: { ...s.rsvpOverride, roleKey },
      })),
    setMemberIdInput: (memberIdInput) =>
      store.setState((s) => ({
        rsvpOverride: { ...s.rsvpOverride, memberIdInput },
      })),
    resetRsvpOverride: () =>
      store.setState({ rsvpOverride: { ...INITIAL_RSVP_OVERRIDE } }),
  }

  return { store, actions }
}

export type GuildEventsAdminDetailStore = ReturnType<
  typeof createGuildEventsAdminDetailStore
>

export const useRsvpOverrideForm = (s: GuildEventsAdminDetailStore) =>
  useStore(s.store, (st) => st.rsvpOverride)

const routeApi = getRouteApi("/_authed/_admin/guild-events/$eventId")

export const useGuildEventsDetailRouteStore = () =>
  routeApi.useRouteContext({
    select: (ctx) => ctx.guildEventsDetailStore,
  })
